var _ellipse, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1336,
    cy: 13.0935,
    rx: 13.1336,
    ry: 13.0935,
    fill: "#B02C17",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_9710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.224 6.89646C16.3977 6.72278 16.6039 6.58501 16.8308 6.49101C17.0578 6.39701 17.301 6.34863 17.5466 6.34863C17.7922 6.34863 18.0355 6.39701 18.2624 6.49101C18.4893 6.58501 18.6955 6.72278 18.8692 6.89646C19.0429 7.07015 19.1807 7.27634 19.2747 7.50327C19.3687 7.7302 19.417 7.97342 19.417 8.21904C19.417 8.46467 19.3687 8.70789 19.2747 8.93482C19.1807 9.16175 19.0429 9.36794 18.8692 9.54163L9.94178 18.469L6.30469 19.461L7.29662 15.8239L16.224 6.89646Z",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_9710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.871,
    height: 15.871,
    fill: "white",
    transform: "translate(5.51123 3.96777)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c08ed42fe33133a32b1b9213b194a933.svg";
export { ForwardRef as ReactComponent };